import React from 'react';
import { ProgressIndicator } from '@veneer/core';
import * as T from './types';

const VeneerLoader: T.VeneerLoaderType = ({ appearance }) => {
  return <ProgressIndicator appearance={appearance} />;
};

export default VeneerLoader;
